<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 2 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/social']"
          >Social Main</a
        >
        <a
          class="btn btn-dark btn-sm btn-new ms-2"
          [routerLink]="['/observability/social/audits']"
          >Audits & Incidents</a
        >
        <a
          class="btn btn-dark btn-sm btn-new ms-2"
          [routerLink]="['/observability/social/executive']"
          >Executive View</a
        >
        <a class="btn btn-dark btn-sm btn-reg ms-2">Leads & Community</a>
      </div>
    </div>
  </div>
  <br />

  <div class="row mb-4">
    <div class="col-md-3 mb-3">
      <div
        class="lead-card p-3 shadow-sm bg-white rounded border-top border-4 border-info h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-users me-2"></i>Total Leads
        </h6>
        <div class="fs-3 fw-bold text-dark">{{ totalLeads }}</div>
      </div>
    </div>

    <div class="col-md-3 mb-3">
      <div
        class="lead-card p-3 shadow-sm bg-white rounded border-top border-4 border-success h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-check-circle me-2"></i>Valid Leads Rate
        </h6>
        <div class="d-flex justify-content-between align-items-baseline mb-1">
          <span class="fs-3 fw-bold text-success">{{
            formatPercent(validLeadRate)
          }}</span>
          <span class="small text-muted">{{ validLeads }} valid</span>
        </div>
        <div class="progress" style="height: 6px">
          <div
            class="progress-bar bg-success"
            [style.width.%]="validLeadRate * 100"
          ></div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-3">
      <div
        class="lead-card p-3 shadow-sm bg-white rounded border-top border-4 border-primary h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-funnel-dollar me-2"></i>Booking Rate
        </h6>
        <div class="d-flex justify-content-between align-items-baseline mb-1">
          <span class="fs-3 fw-bold text-primary">{{
            formatPercent(bookingRate)
          }}</span>
          <span class="small text-muted">{{ bookedLeads }} booked</span>
        </div>
        <div class="progress" style="height: 6px">
          <div
            class="progress-bar bg-primary"
            [style.width.%]="bookingRate * 100"
          ></div>
        </div>
      </div>
    </div>

    <div class="col-md-3 mb-3">
      <div
        class="lead-card p-3 shadow-sm bg-white rounded border-top border-4 border-warning h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-stopwatch me-2"></i>Avg SLA Response
        </h6>
        <div class="fs-3 fw-bold text-warning">
          {{ avgResponseTimeMs / 60000 | number: "1.0-1" }}
          <small class="text-muted" style="font-size: 1rem">min</small>
        </div>
      </div>
    </div>
  </div>

  <!--  Search bar  -->
  <div class="row mb-3 mt-2">
    <div class="col-md-5">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search by message, intent, platform..."
          (keyup)="applyFilter($event)"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent">
          <i class="fas fa-search text-dark"></i>
        </span>
      </div>
    </div>
    <div class="col-md-3 d-flex align-items-center">
      <span *ngIf="loading" class="text-muted ms-2">
        <i class="fas fa-spinner fa-spin me-1"></i> Loading…
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm border-0 rounded">
        <div class="card-header bg-white border-0 py-3">
          <h6 class="mb-0 text-muted text-uppercase fw-bold">
            <i class="fas fa-list me-2"></i>Social Leads Recent Activity
          </h6>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="obs-table mb-0">
              <thead>
                <tr>
                  <th class="general-cell">Platform / Entry</th>
                  <th>Message (Resumido)</th>
                  <th>Intent Classification</th>
                  <th>Validation</th>
                  <th class="general-cell">Handoff TB</th>
                  <th class="general-cell">Booking Flow</th>
                  <th class="general-cell">SLA Response</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="filteredLeads.length > 0; else noLeads">
                  <tr *ngFor="let l of filteredLeads">
                    <td style="min-width: 140px">
                      <div class="fw-bold text-capitalize">
                        <i
                          [class]="getPlatformIcon(l.source_platform) + ' me-1'"
                        ></i>
                        {{ l.source_platform }}
                      </div>
                      <div class="small text-muted text-capitalize mt-1">
                        <i class="fas fa-sign-in-alt me-1"></i
                        >{{ l.entry_point }}
                      </div>
                    </td>

                    <td
                      class="url-cell"
                      (click)="showModal('Message', l.normalized_message)"
                      title="Click to view full Message"
                    >
                      <div class="small fst-italic text-secondary">
                        "{{ l.normalized_message || l.raw_message || "N/A" }}"
                      </div>
                    </td>

                    <!-- Intent Classification -->
                    <td>
                      <span
                        class="badge"
                        [ngClass]="{
                          'bg-primary': l.intent_level === 'high',
                          'bg-info text-dark': l.intent_level === 'medium',
                          'bg-secondary':
                            l.intent_level === 'low' || !l.intent_level,
                          'bg-danger': l.intent_level === 'negative',
                        }"
                      >
                        {{ l.intent_classification || "unknown" | uppercase }}
                      </span>
                    </td>

                    <td>
                      <div *ngIf="l.valid_lead">
                        <i class="fas fa-check-circle text-success me-1"></i>
                        Valid
                      </div>
                      <div *ngIf="!l.valid_lead">
                        <i class="fas fa-times-circle text-danger me-1"></i>
                        Invalid
                        <div class="small text-muted mt-1">
                          {{ l.invalid_reason }}
                        </div>
                      </div>
                    </td>

                    <!-- Handoff Touchbase -->
                    <td>
                      <div *ngIf="l.touch_base_handoff_required">
                        <span class="badge bg-dark fw-normal"
                          ><i class="fas fa-headset me-1"></i
                          >{{ l.touch_base_status }}</span
                        >
                      </div>
                      <div
                        *ngIf="!l.touch_base_handoff_required"
                        class="text-muted small"
                      >
                        Not Req.
                      </div>
                    </td>

                    <td class="text-center">
                      <i
                        class="far fa-circle text-muted"
                        *ngIf="!l.booking_flow_started"
                      ></i>
                      <i
                        class="fas fa-dot-circle text-primary"
                        *ngIf="l.booking_flow_started && !l.booking_completed"
                        title="Started"
                      ></i>
                      <i
                        class="fas fa-check-circle text-success"
                        *ngIf="l.booking_completed"
                        title="Completed"
                      ></i>
                    </td>

                    <!-- SLA Time -->
                    <td
                      class="fw-bold"
                      [ngClass]="{
                        'text-danger': getSlaTime(l) === 'Pending',
                        'text-success': getSlaTime(l) !== 'Pending',
                      }"
                    >
                      {{ getSlaTime(l) }}
                    </td>
                  </tr>
                </ng-container>
                <ng-template #noLeads>
                  <tr>
                    <td colspan="7" class="text-center text-muted py-5">
                      No leads data available.
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
